import { Modal, TimePicker, Button } from "antd";
import { FaCalendarDay } from "react-icons/fa6";
import styles from "../../../styles/Components/alert-system/alert-config/AlertTimeModal.module.css";
import React, { useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import useChangeAlertSystemSettings from "../../../hooks/api/alert-system/useChangeAlertSystemSettings";

const { RangePicker } = TimePicker;

function AlertTimeModal({ open, onClose }) {
  const { activeAlertLoading } = useSelector((state) => state.alertSystem);

  const [timeRange, setTimeRange] = useState([null, null]);
  const changeSettings = useChangeAlertSystemSettings();

  const closeHandler = () => {
    onClose();
  };

  const onTimeChange = (values) => {
    if (!values || values.length !== 2) return;
    setTimeRange(values);

    // values[0] و values[1] از نوع dayjs هستن → تبدیل به moment
    // const start = moment(values[0].toDate());
    // const end = moment(values[1].toDate());
    //
    // console.log("📍 Start (Local):", start.format());
    // console.log("📍 End   (Local):", end.format());
    //
    // console.log("🌍 Start (UTC):", start.utc().format());
    // console.log("🌍 End   (UTC):", end.utc().format());
  };

  console.log(timeRange);
  const submitHandler = (e) => {
    e.stopPropagation();
    if (!timeRange[0] || !timeRange[1]) return;

    const start = moment(timeRange[0].toDate());
    const end = moment(timeRange[1].toDate());

    changeSettings({
      startTime: start.utc().format(),
      endTime: end.utc().format(),
      notificationTime: start.utc().format(),
    }).then(() => onClose());
  };

  return (
    <Modal
      open={open}
      onCancel={closeHandler}
      title={
        <div className={styles.modalTitleContainer}>
          <FaCalendarDay className={styles.modalIcon} />
          <span>Choose Alert Time Range</span>
        </div>
      }
      footer={null}
    >
      <div className={styles.timePicker}>
        <RangePicker
          format="HH:mm a"
          onChange={onTimeChange}
          minuteStep={5}
          showNow={false}
          value={[timeRange?.[0], timeRange?.[1]]}
        />
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.submitBtn}
          loading={activeAlertLoading}
          disabled={!timeRange?.[0] || !timeRange?.[1]}
          onClick={submitHandler}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
}

export default AlertTimeModal;
